import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAllFilesAndFoldersByUserDto } from '../types/FolderPermission';

interface ResourceAddedSliceState {
  addedRow: GetAllFilesAndFoldersByUserDto | null;
  type: string;
}

const initialState: ResourceAddedSliceState = {
  addedRow: null,
  type: ""
};

const resourceAddedSlice = createSlice({
  name: 'ResourceAdded',
  initialState,
  reducers: {
    setResourceAdded(state, action: PayloadAction<{ addedRow: GetAllFilesAndFoldersByUserDto | null; type: string }>) {
      state.addedRow = action.payload.addedRow;
      state.type = action.payload.type;
    },
    clearResourceAdded(state) {
      state.addedRow = null;
      state.type = "";
    },
  },
});

export const { setResourceAdded, clearResourceAdded } = resourceAddedSlice.actions;

export default resourceAddedSlice.reducer;
